import { useOwnedStation } from '@app/core/stations/hooks/useOwnedStation';
import { useStationsFinder } from '@app/core/stations/hooks/useStations';
import {
  SocialExportGetStationConnectionStateDto,
  useSocialExportListConnectionsByStation,
} from '@mi-front/api-v2';

/**
 * Raw social-export connections assigned to a station, plus a loading gate.
 * Prefer {@link useStationPlatformConnections} when filtering by platform.
 * Skips the request for shared stations (social publish is owner-only).
 */
export function useStationConnections(stationId: string | undefined) {
  const ownedStation = useOwnedStation(stationId);
  const findStation = useStationsFinder();
  const stationFound = !!stationId && !!findStation(stationId);

  const connectionsQuery = useSocialExportListConnectionsByStation(stationId ?? '', {
    query: { enabled: !!ownedStation },
  });

  const connections: SocialExportGetStationConnectionStateDto[] =
    connectionsQuery.data?.results ?? [];

  // Resolved once the station is known: owned stations wait for the query;
  // shared stations resolve immediately with an empty list (no fetch).
  const areConnectionsResolved = stationFound && (!ownedStation || !connectionsQuery.isLoading);

  return {
    connectionsQuery,
    connections,
    areConnectionsResolved,
  };
}
